import { useRef } from 'react'

import { getIsGretaAIChatLastTurnQuestion } from './useGretaAIChatTimedOutTurns.utils'

export function useGretaAIChatTimedOutTurns() {
  const timedOutQuestionsRef = useRef(new Map())
  const timeoutStopsRef = useRef(new Set())

  function markTurnTimedOut(conversationId, question) {
    timedOutQuestionsRef.current.set(conversationId, question.trim())
    timeoutStopsRef.current.add(conversationId)
  }

  function settleTimeoutStop(conversationId) {
    timeoutStopsRef.current.delete(conversationId)
  }

  function clearTimedOutTurn(conversationId) {
    timedOutQuestionsRef.current.delete(conversationId)
  }

  function getIsTimeoutStopPending(conversationId) {
    return timeoutStopsRef.current.has(conversationId)
  }

  // Loaded history is authoritative — once the question isn't the last turn, drop it.
  function syncTimedOutTurn(conversationId, loadedMessages) {
    const isPending = getIsGretaAIChatLastTurnQuestion(
      loadedMessages,
      timedOutQuestionsRef.current.get(conversationId)
    )

    if (!isPending) {
      clearTimedOutTurn(conversationId)
    }

    return isPending
  }

  return {
    clearTimedOutTurn,
    getIsTimeoutStopPending,
    markTurnTimedOut,
    settleTimeoutStop,
    syncTimedOutTurn,
  }
}
